import { render, staticRenderFns } from "./vue-tags-input.vue?vue&type=template&id=61d92e31&scoped=true&"
import script from "./vue-tags-input.js?vue&type=script&lang=js&"
export * from "./vue-tags-input.js?vue&type=script&lang=js&"
import style0 from "./vue-tags-input.scss?vue&type=style&index=0&id=61d92e31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d92e31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\johan\\dev\\vue-tags-input\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('61d92e31', component.options)
    } else {
      api.reload('61d92e31', component.options)
    }
    module.hot.accept("./vue-tags-input.vue?vue&type=template&id=61d92e31&scoped=true&", function () {
      api.rerender('61d92e31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue-tags-input/vue-tags-input.vue"
export default component.exports